module.exports = __webpack_public_path__ + "static/media/sorting.3e87c317.svg";